/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { useEffect, useRef, useState } from 'react';
import { Button, DatePicker, Space, Spin, Switch, Table } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import { IconButton, Tooltip } from '@mui/material';

import axios from '../apiClient';
import Alert from '../alert';
import { useLocation, useNavigate } from 'react-router-dom';


// const data = [
//   {
//     id: 0,
//     name: 'Premier League',
//     children: [
//       {
//         id: 1,
//         name: 'John',
//       },
//       {
//         id: 1,
//         name: 'hello',
//       },
//     ],
//   },
//   {
//     id: 2,
//     name: 'jager League',
//     children: [
//       {
//         id: 100,
//         name: 'John Brown',
//         age: 42,
//         address: 'New York No. 2 Lake Park',
//       },
//       {
//         id: 3,
//         name: 'hello',
//         age: 42,
//         address: 'New York No. 2 Lake Park',
//       },
//     ],
//   },

// ];

let refresh=false
const App = ({socket}) => {
  const [date,setDate] = useState('')
  const [matchResults,setMatchResults] = useState([])
  const [loading,setLoading] = useState(true)
  const [settleStatementLoading,setSettleStatementLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [expandRowKeys, setExpandRowKeys] = useState([]);

  const confirmedHTMatches = useRef([])

  const navigate = useNavigate();
  const location = useLocation();

  const didMount = useRef(false)

  const getSettleElement = (data) => {
    const { settle, matchStatus: status, matchId, confirmStatus } = data;
    const editColor = "#4E6E81";
    const isConfirmed = (period) =>
      confirmStatus.some(x => x.periods === period && x.confirmed === '1');
    const needsConfirm = (period) =>
      confirmStatus.some(x => x.periods === period && x.confirmed === '0');

    const renderSettle = () => {
      if (settle === "calculated") return <span style={{ color: "blue" }}>calculated</span>;
      if (settle === "completed") return <span style={{ color: "#ff03f5" }}>completed</span>;
      return settle;
    };

    // if(matchId == "1324252"){
    //   console.log("Match ID 1324252 found");
    //   console.log("include: ", confirmedHTMatches.current.includes(matchId));
    //   console.log("status: ", status);
    //   console.log("needsConfirm full_time: ", needsConfirm('full_time'));
    //   console.log("isConfirmed full_time: ", isConfirmed('full_time'));
    //   console.log("needsConfirm first_time: ", needsConfirm('first_time'));
    //   console.log("isConfirmed first_time: ", isConfirmed('first_time'));
    // }

    if (!confirmedHTMatches.current.includes(matchId)) {
      if (status === "FT" || status === "AET" || status === "PEN") {
        if (needsConfirm('full_time')) {
          console.log("Inside------")
          return (
            <Button
              onClick={() => handleHTComfirm(data)}
              css={css`color: black;border-color: ${editColor};:hover{border-color: ${editColor};};`}
              color='success'
              variant="outlined"
              startIcon={<EditRoundedIcon css={css`color: ${editColor};`} />}
            >
              FT Confirm
            </Button>
          );
        }
        if (needsConfirm('first_time')) {
          return (
            <Button
              onClick={() => handleHTComfirm(data)}
              css={css`color: black;border-color: ${editColor};:hover{border-color: ${editColor};};`}
              color='success'
              variant="outlined"
              startIcon={<EditRoundedIcon css={css`color: ${editColor};`} />}
            >
              HT Confirm
            </Button>
          );
        }
        if (isConfirmed('full_time')) return renderSettle();
      }

      if (status === "HT" || status === "2H") {
        if (needsConfirm('first_time')) {
          return (
            <Button
              onClick={() => handleHTComfirm(data)}
              css={css`color: black;border-color: ${editColor};:hover{border-color: ${editColor};};`}
              color='success'
              variant="outlined"
              startIcon={<EditRoundedIcon css={css`color: ${editColor};`} />}
            >
              HT Confirm
            </Button>
          );
        }
        if (isConfirmed('first_time')) return renderSettle();
      }
    }
    return renderSettle();
  }

  const columns = [
    {
      title: 'Kickoff Time',
      dataIndex: 'matchDate',
      key: 'key',
    },
    {
      title: 'Match',
      dataIndex: 'name',
      key: 'key',
    },
    {
      title: 'Match Status',
      dataIndex: 'matchStatus',
      key: 'key',
    },
    {
      title: '1st Half Score',
      dataIndex: 'firstHalfScore',
      key: 'key',
    },
    {
      title: '2nd Half Score',
      dataIndex: 'secondHalfScore',
      key: 'key',
    },
    {
      title: 'Full Time Score',
      dataIndex: 'fullTimeScore',
      key: 'key',
    },
    {
      title: 'settle',
      render: (data)=> getSettleElement(data),
    },
    {
      title: 'Action',
      render: (data) => {
        const editColor = "#4E6E81"
  
        if(data.children){
          return(
            ""
          )
        }else{
          return (
          <Space size="middle">
            <Tooltip title="Edit">
              <IconButton
                onClick={() => handleEdit(data)}
                css={css`background-color: #ede7f6;`}
                size="small"
              >
                <EditRoundedIcon css={css`color: ${editColor};`} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Odd Logs">
              <IconButton
                onClick={() => navigate(`/reports/oddLogs?matchId=${data.matchId}`,{state: {date: date}})}
                css={css`background-color: #ede7f6;`}
                size="small"
              >
                <HistoryRoundedIcon css={css`color: ${editColor};`} />
              </IconButton>
            </Tooltip>
          </Space>
          )
        }
  
      },
    },
  ];
  useEffect(()=>{
    if(location.state){
      setDate(location.state.date)
    }else{
      const today = moment().format('DD-MM-YYYY');
      setDate(today)
    }
    socket.on('matchConfirmed',(data)=> {
      console.log('matchConfirmed data ',data)
      if(data.status=='HT'){
       fetchData()
      }
     //  if(refresh==false){
     //   refresh=true
     //   setTimeout(() => {
     //     refresh=false
     //     fetchData()
     //   }, 3000);
     //  }
    
   });
   return () => {
       socket.off('matchConfirmed');
   };
  },[])

  useEffect(()=>{
    if(didMount.current == true){
      const arr = matchResults.map(v=>v.key)
      setExpandRowKeys(arr)
    }
  },[matchResults])

  async function fetchData() {
    setLoading(true)
    let res = await axios.get(`/report/getMatchResultForOwnerId?matchDate=${moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD')}`)
    

    if (res.code != 200) {
        if(res.code == 404){
            setLoading(false)
            setMatchResults([])
            return
        }
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
        setLoading(false)
        return
      }
      
    const formattedData = res.data.map((vv,index) => {
        return {
          matchId: vv.matchId,
          confirmStatus: vv.confirmStatus,
          settle: vv.current,
          name : vv.homeTeam.name_en + "-" + vv.awayTeam.name_en,
          id: index,
          matchDate : moment(vv.matchDate).format("DD-MM-YYYY h:mm A"),
          matchStatus : vv.status,
          firstHalfScore: vv.scores.halftime.home != null ? vv.scores.halftime.home + "-" + vv.scores.halftime.away : "-",
          secondHalfScore: vv.scores.fulltime.home != null ? (vv.scores.fulltime.home - vv.scores.halftime.home) + "-" + (vv.scores.fulltime.away -vv.scores.halftime.away) : "-",
          fullTimeScore : vv.scores.fulltime.home != null ? vv.scores.fulltime.home + "-" + vv.scores.fulltime.away : "-",
        }
      
    })
    setMatchResults(formattedData)
    setLoading(false)
  }
  
  useEffect(()=>{
    if(didMount.current){
      fetchData()
    }else{
      didMount.current = true
    }
  },[date])

  const handleEdit = (rowData) => navigate("/reports/matchResultEdit",{state: {rowData: rowData,date}})

  const handleDateChange = (value,dateString) => setDate(dateString)

  const handleCloseAlert = () => setOpenAlert(false)
  
  const handlePay = async () => {
    setSettleStatementLoading(true)
    let data = await axios.post(`/bet/setStatement`)
    setErrorMsg({ code: data.code, msg: data.message })
    setOpenAlert(true)
    setSettleStatementLoading(false)
  }

  const handleHTComfirm = async ({matchId}) => {
    let data = await axios.put(`/bet/updateMatchCalculate?matchId=${matchId}`)
    if(data.code == "200"){
      confirmedHTMatches.current.push(matchId);
    }
    setErrorMsg({ code: data.code, msg: data.message })
    setOpenAlert(true)
    fetchData()
  }


  return (
    <>
     <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
      <div style={{display: 'flex',justifyContent: 'space-between'}}>
        <Space
          align="center"
          style={{
            marginBottom: 16
          }}
        >
           <DatePicker onChange={handleDateChange} format={'DD-MM-YYYY'} value={date ? dayjs(date,"DD-MM-YYYY") : ''}/>
        </Space>
        <div>
          <Spin spinning={settleStatementLoading} size='small'>
          <Button disabled={!matchResults.some(v=> v.settle == "calculated")}  onClick={()=>handlePay()} style={{backgroundColor: "#c3ace6"}} css={css`color: black;border-color: "#4E6E81";:hover{border-color: "#4E6E81";color: black !important};`}  variant="outlined" >
              Settle Statements
          </Button>
          </Spin>
        </div>
      </div>
      <Table
        columns={columns}
        loading={loading}
        rowClassName = {(record,index)=> 'table-row-light-violet'}
        dataSource={matchResults}
        pagination={false}
        expandable={{expandRowByClick: false,expandIcon: ()=> null,expandedRowKeys: expandRowKeys}}
      />
    </>
  );
};
export default App;
